import React from "react";

import BooleanInput from "./BooleanInput";
import DeleteButton from "../../buttons/DeleteButton";

import '../_static/FileBox.css'
import ChangeCheckContext from "../support/ChangeCheckContext";
import EditButton from "../../buttons/EditButton";
import Col from "react-bootstrap/Col";

function FileBox(props) {

    const {disable} = React.useContext(ChangeCheckContext)

    return (
        <tr>
            <td className="FileBoxCell">
                <div className="FileBoxDiv">
                    {props.getImage()}
                </div>
            </td>
            <td className="FileBoxCell">
                <div className="FileBoxDiv mb-3">
                    {props.getFileElement()}
                </div>
            </td>
            <td className="FileBoxCell">
                <div className="FileBoxDiv">
                    {

                        props.checkPrintable() &&
                        <BooleanInput name={props.name} label={'Tlačiť'} value={props.print}
                                      onChange={(event) => props.onChange(props.ndx, event.target.value)}
                                      disabled={disable}/>
                    }
                </div>
            </td>
            <td className="FileBoxCell">
                <div className="FileBoxDiv mb-3">
                    <Col className="d-flex flex-column justify-content-center align-items-center">
                        {props.checkPrintable() && <EditButton onClick={() => props.editImage(props.ndx)}
                                    disabled={disable}/>}
                        <DeleteButton onClick={() => props.delete(props.ndx)}
                                      disabled={disable}/>
                    </Col>
                </div>
            </td>
        </tr>
    )
}

export default FileBox
